import React, { ReactElement, useMemo } from 'react';
import { SALUTATION } from 'b2b-apps/shop/checkout/utils/checkout';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { WrappedComponentProps as Props, WrappedComponentType as ComponentType } from './';

const FullName: ComponentType = (props: Props): ReactElement | null => {
  const t = useTranslate();
  const {
    className,
    ...address
  } = props;
  const {
    salutation,
    firstName,
    lastName,
  } = address;
  const title = useMemo(
    () => {
      switch (salutation) {
        case SALUTATION.male:
          return t('Mr.');

        case SALUTATION.female:
          return t('Ms.');

        case SALUTATION.company:
          return t('Company');

        default:
          return salutation;
      }
    },
    [salutation, t],
  );

  if (!salutation || !firstName || !lastName) {
    return null;
  }

  return (
    <div className={className} data-hj-suppress>
      {title} {firstName} {lastName}
    </div>
  );
};

export { FullName };
